export const actionButtonOptions = [
	{
		label: 'Accept',
		value: 'SUBMIT',
		altCode: 'Accept',
	},
	{
		label: 'Approve',
		value: 'SUBMIT',
		altCode: 'Approve',
	},
	{
		label: 'Cancel',
		value: 'CANCEL',
		altCode: 'Cancel',
	},
	{
		label: 'Delete',
		value: 'CANCEL',
		altCode: 'Delete',
	},
	{
		label: 'Float for Approval',
		value: 'SUBMIT',
		altCode: 'FloatforApproval',
	},
	{
		label: 'Send for Approval',
		value: 'SUBMIT',
		altCode: 'SendforApproval',
	},
	{
		label: 'Pass',
		value: 'SUBMIT',
		altCode: 'Pass',
	},
	{
		label: 'Recommend',
		value: 'SUBMIT',
		altCode: 'Recommend',
	},
	{
		label: 'Revoke',
		value: 'SUBMIT',
		altCode: 'Revoke',
	},
	{
		label: 'Save as Draft',
		value: 'SAVE',
		altCode: 'SaveasDraft',
	},
	{
		label: 'Send back',
		value: 'SEND_BACK',
		altCode: 'Sendback',
	},

	{
		label: 'Reject',
		value: 'REJECT',
		altCode: 'Reject',
	},
	{
		label: 'Update',
		value: 'SAVE',
		altCode: 'Update',
	},
];

export const actionButtonObject = {
	Accept: {
		label: 'Accept',
		value: 'SUBMIT',
		altCode: 'Accept',
	},
	Approve: {
		label: 'Approve',
		value: 'SUBMIT',
		altCode: 'Approve',
	},
	Cancel: {
		label: 'Cancel',
		value: 'CANCEL',
		altCode: 'Cancel',
	},
	Delete: {
		label: 'Delete',
		value: 'CANCEL',
		altCode: 'Delete',
	},
	FloatforApproval: {
		label: 'Float for Approval',
		value: 'SUBMIT',
		altCode: 'FloatforApproval',
	},
	SendforApproval: {
		label: 'Send for Approval',
		value: 'SUBMIT',
		altCode: 'SendforApproval',
	},
	Pass: {
		label: 'Pass',
		value: 'SUBMIT',
		altCode: 'Pass',
	},
	Recommend: {
		label: 'Recommend',
		value: 'SUBMIT',
		altCode: 'Recommend',
	},
	Revoke: {
		label: 'Revoke',
		value: 'SUBMIT',
		altCode: 'Revoke',
	},
	SaveasDraft: {
		label: 'Save as Draft',
		value: 'SAVE',
		altCode: 'SaveasDraft',
	},
	Sendback: {
		label: 'Send back',
		value: 'SEND_BACK',
		altCode: 'Sendback',
	},
	Reject: {
		label: 'Reject',
		value: 'REJECT',
		altCode: 'Reject',
	},
	Update: {
		label: 'Update',
		value: 'SAVE',
		altCode: 'Update',
	},
};
